"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyPeriodSchema = exports.AbsolutePeriodSchema = exports.RelativePeriodSchema = void 0;
const zod_1 = require("zod");
exports.RelativePeriodSchema = zod_1.z.object({
    interval: zod_1.z.enum(['day', 'week', 'month', 'quarter', 'year', 'period']),
    amount: zod_1.z.number(),
});
exports.AbsolutePeriodSchema = zod_1.z.object({
    start: zod_1.z.date({ coerce: true }).openapi({ type: 'string', format: 'date-time' }),
    end: zod_1.z.date({ coerce: true }).openapi({ type: 'string', format: 'date-time' }),
});
exports.AnyPeriodSchema = zod_1.z.union([exports.RelativePeriodSchema, exports.AbsolutePeriodSchema]);
//# sourceMappingURL=periodSchema.js.map